import { render, staticRenderFns } from "./JTWhatsApp.vue?vue&type=template&id=2d3316c0&scoped=true"
import script from "./JTWhatsApp.vue?vue&type=script&lang=js"
export * from "./JTWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./JTWhatsApp.vue?vue&type=style&index=0&id=2d3316c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3316c0",
  null
  
)

export default component.exports